import { defineNuxtPlugin } from "#app";
import { createSocketConnection as createItemCommentsConnection } from "~/api/comments/services/socket-connection";

export default defineNuxtPlugin(() => {
  createItemCommentsConnection();
});
